<template>
<div>
	<div class="role">
		<h3 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">反馈列表 </h3>
		
		<!-- <el-button @click="showDialog('add')" class="add qjc-fts-16">添加优惠码</el-button> -->
		<el-table
			:data="list"
			style="width: 100%"
		>
			<template slot="empty">
				<div class="empty-wrap">
					<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
					<div class="empty-text">暂无数据</div>
				</div>
			</template>
			<el-table-column
				label="编号"
				prop="id"
				width="70"
			></el-table-column>
			<el-table-column
				label="手机号"
				prop="mobile"
				width="200"
			>
				<template slot-scope="scope">
					<div class="">{{scope.row.mobile ? scope.row.mobile : '--'}}</div>
				</template>
			</el-table-column>
			
			<el-table-column
				label="反馈内容"
				prop="content"
			>
				<template slot-scope="scope">
					<div class="content_cell">{{scope.row.content ? scope.row.content : '--'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="日期"
				prop="created_at"
				width="250"
			>
				<template slot-scope="scope">
					<div class="">{{scope.row.created_at ? scope.row.created_at : '--'}}</div>
				</template>
			</el-table-column>
			
			<el-table-column
				label="操作"
				width="150"
			>
				<template slot-scope="scope">
					<el-button class="btn-text" @click="handleDetail(scope.row.id)" type="text">查看</el-button>
				</template>
			</el-table-column>
			
		</el-table>
		
		<!-- 分页 -->
		<el-pagination
			@current-change="pageChange"
			:current-page.sync="pager.page"
			hide-on-single-page
			:page-size="pager.pagesize"
			
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper"
			:total="pager.count">
		</el-pagination>
		
		<el-dialog
		  title="反馈详情"
		  :visible.sync="detailShow"
		  width="60%" 		  :close-on-click-modal="false"
		  class="used_dialog">
				<div class="">
					<div class="detail_cell">
						<div class="detail_cell_title">手机号：</div>
						<div class="detail_cell_val">{{info.mobile ? info.mobile : '--'}}</div>
					</div>
				<div class="detail_cell">
					<div class="detail_cell_title">详细意见：</div>
					<div class="detail_cell_val">{{info.content ? info.content : '--'}}</div>
				</div>
				<div class="detail_cell">
					<div class="detail_cell_title">图片：</div>
					<div class="detail_img_list">
						<img v-for="(item, index) in info.img" @click="showImagePreview(item)"  class="detail_img" :src="item" alt="" >
					</div>
					
				</div>
			  </div>
		</el-dialog>
	</div>
	
</div>
</template>

<script>
	import { getFeedbacksList } from '@/utils/axios.js';
	import { dateStrChangeTimeTamp } from '@/utils';
	
	export default {
		name: 'mainFeedback',
		data() {
			return {
				submiting: false, // 正在请求
				list: [], //列表
				id: '',
				pager: {
					count: 0, // 总条数
					page: 1, // 当前页
					pagecount: 0, // 总页数
					pagesize: 10 // 每页条数
				},
				detailShow: false,
				info: {}
			};
		},
	
		mounted() {
			this.getList();
		},
		components: {},
		watch: {
			
		},
		methods: {
			// 获取列表
			getList() {
				getFeedbacksList(this.pager).then(res => {
					if(res.code == 200){
						this.list = res.data.data;
						this.pager = res.data.pager;
						// 数值可能为字符串，需转换为number
						for(var key in this.pager){
							this.pager[key] = parseInt(this.pager[key]);
						}
						
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
			handleDetail(id) {
				this.detailShow = true
				getFeedbacksList({act: 'detail', id: id}).then(res => {
					if(res.code == 200){
						this.info = res.data
						
					}else{
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			showImagePreview(imageUrl) {
				const image = new Image();
				image.src = imageUrl;
				image.onload = () => {
					// 创建弹出层
					const previewContainer = document.createElement('div');
					previewContainer.style.position = 'fixed';
					previewContainer.style.top = 0;
					previewContainer.style.bottom = 0;
					previewContainer.style.left = 0;
					previewContainer.style.right = 0;
					previewContainer.style.backgroundColor = 'rgba(0,0,0,0.8)';
					previewContainer.style.display = 'flex';
					previewContainer.style.justifyContent = 'center';
					previewContainer.style.alignItems = 'center';
					previewContainer.style.zIndex = 9999;
					document.body.appendChild(previewContainer);
					// 在弹出层中添加图片
					const previewImage = document.createElement('img');
					previewImage.src = imageUrl;
					previewImage.style.maxWidth = '80%';
					previewImage.style.maxHeight = '80%';
					previewContainer.appendChild(previewImage);
					// 点击弹出层，关闭预览
					previewContainer.addEventListener('click', () => {
					  document.body.removeChild(previewContainer);
					});
				};
			},
		}
	};
</script>

<style scoped>
	.el-dialog .el-form .el-form-item >>>  .code_cell .el-input__inner {
		padding-right: 80px !important;
	}
	.el-dialog .el-form .el-form-item >>> .el-date-editor.el-input, .el-dialog .el-form .el-form-item >>> .el-date-editor.el-input__inner {
		width: 100%;
	}
	.el-dialog .el-form .el-form-item >>> .el-select {
		width: 100%;
	}
	.el-dialog .el-form >>> .el-form-item {
		margin-bottom: 8px;
	}
	.el-dialog .el-form >>> .el-form-item__label{
		width: 16%;
		padding-right: 24px;
		margin-left: 4%;
		text-align: right;
	}
	.el-dialog .el-form >>> .el-form-item__content{
		float: left;
		width: 60%;
		margin-right: 0;
	}
	.right-wrap >>> .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #6681FA;
	}
	.right-wrap >>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6681FA;
		border-color: #6681FA;
	}
	.right-wrap >>> .el-switch__core:after {
		background-color: #828DBC;
	}
	.right-wrap >>> .el-switch.is-checked .el-switch__core::after {
		background-color: #6681FA;	
	}
	.right-wrap >>> .el-input-number__increase {
		display: none;
	}
	.right-wrap >>> .el-input-number__decrease {
		display: none;
	}
	.right-wrap .input-number >>> .el-input__inner {
		height: 30px;
		border: none;
		border-bottom: 1px solid #CED4F0;
		border-radius: 0;
		padding: 0;
		margin-left: 10px;
	}
	.used_dialog >>> .el-dialog__body {
		padding: 0 20px 30px;
	}
	::v-deep input::-webkit-outer-spin-button,::v-deep input::-webkit-inner-spin-button{
	  -webkit-appearance: none !important;
	}
	::v-deep input[type='number']{
	  line-height: 1;
	  -moz-appearance: textfield !important;
	}
	.detail_cell {
		display: flex;
		align-items: flex-start;
		margin-top: 60px;
	}
	.detail_cell_val {
		flex: 1;
		max-width: 7rem;
		word-break: break-all;
		word-wrap: break-word;
		white-space: pre-wrap;
	}
	.detail_img_list {
		display: flex;
		align-items: center;
	}
	.detail_img {
		width: 180px;
		height: 180px;
	}
	.content_cell {
		width: 480px;
		white-space: nowrap;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
</style>
<style lang="scss" scoped>
	.role{
		// display: flex;
		width: 100%;
		height: 100%;
		padding: 28px 24px;
		
		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 30px 24px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			
			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;
				
				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;
					
					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}
				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}
			.left-list {
				padding-top: 20px;
			}
			
			.left-enp-item {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				line-height: 20px;
				cursor: pointer;
			}
			.left-enp-item-active {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				line-height: 20px;
			}
		}
		
		.right-wrap {
			flex: 1;
			padding: 36px 24px;
			overflow: auto;
			
			.right-temp {
				margin-bottom: 32px;
				
				.temp-title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 18px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #293033;
					line-height: 24px;
					padding-bottom: 10px;
					border-bottom: 1px solid #E5E8F5;
				}
				
				.temp-info {
					margin-top: 12px;
				}
			}
			
			.submit-btn {
				width: 94px;
				height: 34px;
				font-size: 15px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 34px;
				background-color: #6883FB;
				border-radius: 17px;
				border: none;
				margin-top: 10px;
			}
			.info-cell {
				margin-bottom: 20px;
			}
			.input-number {
				width: 50px;
			}
			.custom-info {
				position: relative;
				width: 670px;
				padding: 24px;
				border: 1px solid #CED4F0;
				border-radius: 4px;
				margin-top: 10px;
				
				&::before {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -16px;
					left: 41px;
					padding: 0;
					border-top: 8px solid transparent;
					border-left: 8px solid transparent;
					border-right: 8px solid transparent;
					border-bottom: 8px solid #fff;
					display: block;
					content: '';
					z-index: 12;
				}
				
				&::after {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -18px;
					left: 40px;
					padding: 0;
					border-top: 9px solid transparent;
					border-left: 9px solid transparent;
					border-right: 9px solid transparent;
					border-bottom: 9px solid #CED4F0;
					display: block;
					content: '';
					z-index: 10;
				}
			}
			.custom-group {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				
				.custom-item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 30%;
					margin-right: 20px;
				}
			}
		}
		
		.add{
			padding: 8px 12px;
			margin: 24px 0 12px;
			color: #fff;
		}
		
		.el-table{
			i[class^=el-icon]{
				margin-right: 16px;
				cursor: pointer;
			}
		}
		
		.el-pagination{
			text-align: center;
			margin-top: 32px;
		}
		
		.el-dialog{
			
			.dialog-title {
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #293033;
				text-align: center;
			}
			.all-power{
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				box-sizing: border-box;
				color: #606266;
				display: inline-block;
				font-size: inherit;
				height: 40px;
				line-height: 40px;
				outline: 0;
				padding: 0 15px;
				transition: border-color .2s cubic-bezier(.645,.045,.355,1);
				width: 100%;
			}
			.dialog-footer{
				display: flex;
				align-items: center;
				justify-content: center;
				.cancel-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #6883FB;
					border: 1px solid #6883FB;
					border-radius: 17px;
					background-color: #fff;
				}
				.submit-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #fff;
					border: none;
					border-radius: 17px;
					background-color: #6883FB;
					margin-left: 16px;
				}
				.el-button{
					padding: 9px 15px;
				}
			}
		}
	}
	
	
	.empty-wrap {
		padding: 100px 0;
	}
	.empty-img {
		width: 338px;
		height: 218px;
	}
	
	.el-icon-edit {
		color: #6681FA;
	}
	
	.user_btn {
		color: #6681FA;
		cursor: pointer;
	}
	
	.el-pagination{
		text-align: center;
		margin-top: 32px;
	}
</style>